// extracted by mini-css-extract-plugin
module.exports = {"button":"ConfirmDetailButton_button__2Ah3b","text":"ConfirmDetailButton_text__1Cqyj"};